<script>

import { Overlay } from '../../'

export default {
    name: 'QQE',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'QQE - Quantitative Qualitative Estimation',
                preset: {
                    name: 'QQE $rsi_length $smooth',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#2196f3',
                        signalColor: '#ff5722'
                    }
                }
            }
        },
        use_for() { return ['QQE'] },
        calc() {
            return {
                props: {
                    rsi_length: { def: 14, text: 'RSI Length' },
                    smooth: { def: 5, text: 'Smooth' },
                    wilders_period: { def: 2.618, text: 'Wilders Period' }
                },
                conf: { renderer: 'Splines' },
                update: `
                    let strength = rsi(close, rsi_length)
                    let average = ema(strength, smooth)
                    let change = ts(Math.abs(average[0] - average[1]))
                    let period = 2 * rsi_length - 1
                    let distance = ema(ema(change, period), period)[0] * wilders_period
                    let longBand = ts(NaN), shortBand = ts(NaN), trend = ts(1)
                    let lower = average[0] - distance, upper = average[0] + distance
                    longBand[0] = average[1] > longBand[1] && average[0] > longBand[1] ? Math.max(longBand[1], lower) : lower
                    shortBand[0] = average[1] < shortBand[1] && average[0] < shortBand[1] ? Math.min(shortBand[1], upper) : upper
                    trend[0] = average[0] > shortBand[1] ? 1 : average[0] < longBand[1] ? -1 : trend[1] || 1
                    return [average[0], trend[0] === 1 ? longBand[0] : shortBand[0], shortBand[0], longBand[0]]
                `
            }
        }
    }
}
</script>
